import { Field, Form } from "react-final-form";

import { LANGUAGE, SOURCE, Source } from "@/constants";
import useSearchParams from "@/hooks/useSearchParams";
import { capitalize } from "@/utils";
import Button from "@components/Button";
import { FF_InputField, FF_SelectField } from "@components/Field";

import styles from "./ChannelListFilter.module.css";

interface SearchParams {
  [key: string]: unknown;
  name?: string;
  language?: string;
  channel_type?: Source;
}

const ChannelListFilter = () => {
  const [searchParams, setSearchParams] = useSearchParams<SearchParams>();

  return (
    <Form<SearchParams>
      onSubmit={(values) => {
        const valuesWithPageSetToOne = {
          ...values,
          page: 1,
        };
        setSearchParams(valuesWithPageSetToOne, true);
      }}
      initialValues={searchParams}
    >
      {({ handleSubmit, dirty }) => (
        <form className={styles.channelListFilter} onSubmit={handleSubmit}>
          <Field
            name="language"
            render={FF_SelectField}
            placeholder="Language"
            nullable
          >
            {Object.entries(LANGUAGE).map(([key, value]) => (
              <option key={value} value={value}>
                {capitalize(key)}
              </option>
            ))}
          </Field>

          <Field
            name="channel_type"
            render={FF_SelectField}
            placeholder="Channel type"
            nullable
          >
            {Object.values(SOURCE).map((channel_type, i) => (
              <option key={i} value={channel_type}>
                {channel_type}
              </option>
            ))}
          </Field>

          <Field
            name="automatic_transcription"
            render={FF_SelectField}
            placeholder="Automatic Transcription"
            nullable
          >
            <option value="1">Yes</option>
            <option value="0">No</option>
          </Field>

          <Field
            name="name"
            placeholder="Channel name"
            render={FF_InputField}
            autoComplete="off"
          />
          <Button type="submit" disabled={!dirty}>
            Filter
          </Button>
        </form>
      )}
    </Form>
  );
};

export default ChannelListFilter;
